import { Component, inject } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent, CardComponent, CardContentComponent } from '@camelot/ui';

import { CAM_AUTH_TOKEN } from '../../services/auth.service';
import { CamTranslationUser } from '../../translation.service';

@Component({
  selector: 'cam-login-card',
  templateUrl: './login-card.component.html',
  styleUrls: ['./login-card.component.scss'],
  imports: [ButtonComponent, CardComponent, CardContentComponent, TranslatePipe],
})
export class LoginCardComponent {
  private _authService = inject(CAM_AUTH_TOKEN);

  constructor() {
    CamTranslationUser.getInstance();
  }

  public login() {
    this._authService.login();
  }
}
